import { ManageSupport } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_SUPPORT.path,
      name: "Manage Support Ticket",
      key: adminRouteMap.MANAGE_SUPPORT.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_SUPPORT.icon,
      element: <ManageSupport />,
    },
  ];
}
